import {
  UPDATE_ALL_WIDGETS,
  UPDATE_WIDGET,
  SIDE_UPDATE_WIDGET
} from '../actions/widgetsActions'
import { arraysEqual } from '../../utils'

/**
 * Widget reducer
 * @module  {Reducer} widgetsReducer
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
export default (state = {}, action) => {
  switch (action.type) {
    case UPDATE_ALL_WIDGETS:
      if (arraysEqual(Object.keys(state), Object.keys(action.widgets || {}))) {
        return { ...action.widgets }
      } else {
        return Object.keys(action.widgets).reduce((newState, k) => {
          newState[k] = { ...state[k], ...action.widgets[k] }
          return newState
        }, {})
      }
    case UPDATE_WIDGET:
    case SIDE_UPDATE_WIDGET:
      return {
        ...state,
        [action.widget.name]: {
          ...state[action.widget.name],
          ...action.widget
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./state/reducers/widgetsReducer.js